var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypal-advanced-giftcard"},[_c('div',{staticClass:"paypal-button-container",attrs:{"id":"paypal-button-container"}}),_vm._v(" "),(this.data.googlePay)?_c('div',{staticClass:"gpay-button-custom",attrs:{"id":"container"}}):_vm._e(),_vm._v(" "),_c('p',{attrs:{"id":"result-message"}},[_vm._v(_vm._s(_vm.resultMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }